import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_TARGET_LIST_RESULT: DyTableColumn[] = [
  {
    dataKey: 'patientId',
    label: 'Patient ID',
    width: 200,
    type: 'number',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 300,
    type: 'text',
  },
  // {
  //   dataKey: 'treatmentDetails',
  //   label: 'Treatment Details',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 200,
    type: 'currency',
  },
  // {
  //   dataKey: 'dueDate',
  //   label: 'Due Date',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'provider',
    label: 'Provider',
    width: 300,
    type: 'text',
  },
  // {
  //   dataKey: 'payor',
  //   label: 'Payor',
  //   width: 100,
  //   type: 'text',
  // },
  // {
  //   dataKey: 'arAge',
  //   label: 'A/R Age',
  //   width: 100,
  //   type: 'text',
  // },
  // {
  //   dataKey: 'arBucket',
  //   label: 'A/R Bucket',
  //   width: 100,
  //   type: 'text',
  // },
  // {
  //   dataKey: 'claimStatus',
  //   label: 'Claim Status',
  //   width: 100,
  //   type: 'status',
  // },
];

export const TABLE_CONFIG_COLUMNS_CAMPAIGN_PAID_PATIENTS : DyTableColumn[] = [
  {
    dataKey: 'patientId',
    label: 'Patient ID',
    width: 200,
    type: 'number',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 300,
    type: 'text',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'provider',
    label: 'Provider',
    width: 300,
    type: 'text',
  },
];